import {Alert, Rate, Space, Spin, Table} from "antd";
import {StyledPageHeader} from "../../../styles/dashboard/calls/calls";
import {StyledAverageRatingsColumnsWrapper} from "./styles";
import type {ColumnsType} from "antd/es/table";
import {useGetAverageRatings} from "../../../react-query-hooks/reviews/average-ratings";
import {LoadingSpinner} from "../../icons/icons";

interface DataType {
  key: string;
  offering: string;
  averageRating: string;
  ratingCount: string;
}

const columns: ColumnsType<DataType> = [
  {
    title: "Offering",
    dataIndex: "offering",
    key: "offering",
    render: (text) => <>{text}</>,
  },
  {
    title: "Average",
    dataIndex: "averageRating",
    key: "averageRating",
    render: (text, record) => (
      <>
        <Space size={8} direction="vertical" style={{display: "flex"}}>
          <Rate
            disabled
            defaultValue={+record.averageRating}
            style={{color: "#99C78F"}}
            allowHalf
          />
          <p className="column-header-text">
            {+record.averageRating}/5 based on {record.ratingCount} reviews
          </p>
        </Space>
      </>
    ),
  },
];

export function AverageRatingsSection() {
  const getAverageRatings = useGetAverageRatings();

  if (getAverageRatings.isLoading) {
    return (
      <div>
        <Spin spinning indicator={LoadingSpinner}>
          <div
            style={{
              height: "30rem",
            }}
          ></div>
        </Spin>
      </div>
    );
  }

  if (getAverageRatings.error) {
    return (
      <Alert
        message="Error"
        description={getAverageRatings.error.message ?? "Error fetching Average reviews"}
        type="error"
        showIcon
      />
    );
  }

  const data: DataType[] = getAverageRatings.data.data.map((a) => ({
    averageRating: a.avg_rating,
    key: a.offering_id.toString(),
    offering: a.offering_name ?? "No offering name",
    ratingCount: a.rating_count,
  }));

  return (
    <Space size={24} direction="vertical" style={{display: "flex"}}>
      <StyledPageHeader>Average ratings</StyledPageHeader>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        loading={getAverageRatings.isFetching}
        scroll={{x: 100}}
      />
    </Space>
  );
}
